import { render, staticRenderFns } from "./DetailListItem.vue?vue&type=template&id=7943aa1a&scoped=true&"
import script from "./DetailListItem.vue?vue&type=script&lang=js&"
export * from "./DetailListItem.vue?vue&type=script&lang=js&"
import style0 from "./DetailListItem.vue?vue&type=style&index=0&id=7943aa1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7943aa1a",
  null
  
)

export default component.exports